import { LegsSystem, RangeComponent } from '@inter-ikea-storageone/range';
import { ComponentIds } from '@inter-ikea-core/core';
import { BehaviorParameters } from 'rangeConfig/@types';

const replaceLegs = ({ coreApi, props }: BehaviorParameters) => {
  const selectedLeg = coreApi.entities.findSelectedEntity();
  const selectedLegRange = selectedLeg?.getComponent<RangeComponent>(RangeComponent.id)?.range;
  const system = coreApi.getSystem<LegsSystem>('LegsSystem');
  if (!system) {
    return;
  }

  system.updateLegsWithHistory(props.coreProductId);
  const legs = coreApi.entities.getByComponent(ComponentIds.LEG_COMPONENT_ID, selectedLegRange);
  if (legs.length > 0) {
    coreApi.entities.select(legs[0]);
  }
};

export default replaceLegs;
